<template>
  <div>
    <breadcrumb :routerList="[{to:'/abnormal/applyList',title:'异常数据申请列表'},{title:'异常数据申请审批'}]"/>
    <div class="h-content">
      <div class="h-row h-mrt0">
        <div class="h-rowIn">
          <div class="h-rowBox">
            <div class="h-rowCon">
              <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                  <h1>基本信息</h1>
                </div>
                <div class="h-pieceCon2">
                  <div class="h-formLine Yangbiao">
                    <el-form :model="form" label-position="right" :inline="true" class="demo-ruleForm h-formbLine h-formbLine1" disabled>
                      <el-form-item label="单号" class="h-elformWrap-2">
                        <el-input v-model="form.applyno" readonly/>
                      </el-form-item>
                      <el-form-item label="状态" class="h-elformWrap-2">
                        <el-input :value="getStatusName(form.status)" readonly/>
                      </el-form-item>
                      <el-form-item label="业务模块" class="h-elformWrap-2">
                        <dictname category="abnormal_business_module" :v="form.businessModule"/>
                      </el-form-item>
                      <el-form-item label="申请人" class="h-elformWrap-2">
                        <el-input v-model="form.cuname" readonly/>
                      </el-form-item>
                      <el-form-item label="问题说明" class="h-elformWrap-1">
                        <el-input v-model="form.problemDesc" type="textarea" :rows="3" readonly style="border: #dedede 1px solid;"/>
                      </el-form-item>
                      <el-form-item label="期望修改内容" class="h-elformWrap-1">
                        <el-input v-model="form.expectContent" type="textarea" :rows="3" readonly style="border: #dedede 1px solid;"/>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
                <div class="h-pieceCon2" v-if="applyFiles.length > 0">
                  <div class="h-formLine Yangbiao">
                    <el-form :model="form" label-position="right" :inline="true" class="demo-ruleForm h-formbLine h-formbLine1" disabled>
                      <el-form-item label="申请附件" class="h-elformWrap-1">
                        <brupload
                          :refid="form.id"
                          reftype="abnormal_apply"
                          :uploadflag="false"
                          :delflag="false">
                        </brupload>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--运维信息（运维接收和运维完成节点显示）-->
      <div class="h-row" v-if="isYwReceive || isYwComplete">
        <div class="h-rowIn">
          <div class="h-rowBox">
            <div class="h-rowCon">
              <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                  <h1>运维信息</h1>
                </div>
                <div class="h-pieceCon2">
                  <div class="h-formLine Yangbiao">
                    <el-form :model="ywForm" :rules="ywRules" ref="ywForm" label-position="right" :inline="true" class="demo-ruleForm h-formbLine h-formbLine1">
                      <el-form-item label="问题类型" class="h-elformWrap-35" prop="problemType">
                        <brselect :v="ywForm.problemType" v-model="ywForm.problemType" category="abnormal_problem_type" placeholder="请选择问题类型" clearable/>
                      </el-form-item>
                      <el-form-item v-if="isYwComplete" label="解决方案" class="h-elformWrap-1" prop="solution">
                        <el-input v-model="ywForm.solution" type="textarea" :rows="3" placeholder="请填写解决方案" style="border: #dedede 1px solid;"/>
                      </el-form-item>
                      <el-form-item v-if="isYwComplete" label="解决附件" class="h-elformWrap-1">
                        <brupload
                          :refid="form.id || ''"
                          reftype="abnormal_solve"
                          :uploadflag="true"
                          :delflag="true">
                        </brupload>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--审批意见-->
      <div class="h-row">
        <div class="h-rowIn">
          <div class="h-rowBox">
            <div class="h-rowCon">
              <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                  <h1>审批意见</h1>
                </div>
                <div class="h-pieceCon2">
                  <div class="h-formLine Yangbiao">
                    <el-form :model="approveForm" :rules="approveRules" ref="approveForm" label-position="right" :inline="true" class="demo-ruleForm h-formbLine h-formbLine1">
                      <el-form-item label="审批意见" class="h-elformWrap-3" prop="approveOpinion" :required="true">
                        <el-input v-model="approveForm.approveOpinion" placeholder="请输入"/>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <viewhistory :visible.sync="showTrackDialog" v-if="showTrackDialog" :id="instid"/>

      <div class="h-txtCenter h-mrt60">
        <el-button class="h-btn h-bBtn h-bgwhite" @click="handleBack">返回</el-button>
        <el-button v-if="taskstatus === 0" class="h-btn h-bBtn h-bgred" @click="handleApprove('REJECT')">驳回</el-button>
        <el-button v-if="taskstatus === 0" class="h-btn h-bBtn h-bggreen" @click="handleApprove('PASS')">通过</el-button>
        <el-button class="el-button h-btn el-button--default" @click="handleTrack">审批跟踪</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import ApplyService from '@/api/abnormal/ApplyService';

export default {
  data() {
    return {
      form: {},
      applyFiles: [],
      ywForm: {
        problemType: '',
        solution: ''
      },
      approveForm: {
        approveOpinion: ''
      },
      instid: '',
      taskid: '',
      taskstatus: 0,
      showTrackDialog: false,
      statusMap: {
        0: '草稿',
        1: '待IT接口人审批',
        2: '待运维处理',
        3: '处理中',
        4: '已完成',
        5: '已驳回'
      },
      ywRules: {
        problemType: [{ required: true, message: '请选择问题类型', trigger: 'change' }]
      },
      approveRules: {
        approveOpinion: [{ required: true, message: '请输入审批意见', trigger: 'blur' }]
      }
    };
  },
  computed: {
    isYwReceive() {
      return this.form.status === 2;
    },
    isYwComplete() {
      return this.form.status === 3;
    }
  },
  created() {
    this.taskid = this.$route.query.taskid;
    this.instid = this.$route.query.instid;
    this.taskstatus = parseInt(this.$route.query.taskstatus || '0');
    this.loadDetail();
  },
  methods: {
    getStatusName(status) {
      return this.statusMap[status] || '';
    },
    async loadDetail() {
      try {
        const ywid = this.$route.query.ywid;
        const res = await ApplyService.detail(ywid);
        if (res.f && res.obj) {
          this.form = res.obj.apply || {};
          this.applyFiles = res.obj.applyFiles || [];
          this.ywForm.problemType = this.form.problemType || '';
          this.ywForm.solution = this.form.solution || '';
        }
      } catch (e) {
        console.error(e);
      }
    },
    async handleApprove(approveType) {
      try {
        if (approveType === 'PASS') {
          if (this.isYwReceive) {
            if (!this.ywForm.problemType) {
              this.$message.error('请选择问题类型');
              return;
            }
          }
          if (this.isYwComplete) {
            if (!this.ywForm.solution) {
              this.$message.error('请填写解决方案');
              return;
            }
          }
          if (!this.approveForm.approveOpinion) {
            this.approveForm.approveOpinion = '通过';
          }
        } else {
          if (!this.approveForm.approveOpinion) {
            this.$message.error('请输入审批意见');
            return;
          }
        }

        const data = {
          id: this.form.id,
          taskId: this.taskid,
          approveType: approveType,
          approveOpinion: this.approveForm.approveOpinion,
          problemType: this.ywForm.problemType,
          solution: this.ywForm.solution
        };

        const res = await ApplyService.approve(data);
        if (res.f) {
          this.$message.success(res.msg || '审批成功');
          this.$store.dispatch('searchTasktotal');
          this.$router.push({ path: '/personal/dealCenter' });
        } else {
          this.$message.error(res.msg || '审批失败');
        }
      } catch (e) {
        console.error(e);
      }
    },
    handleTrack() {
      this.showTrackDialog = true;
    },
    handleBack() {
      this.$router.push({ path: '/personal/dealCenter' });
    }
  }
};
</script>
<style>
.Yangbiao .h-elformWrap-2 .el-form-item__label {
  width: 45%;
  text-align: right;
}

.Yangbiao .el-form-item__content {
  width: 55%;
}

.Yangbiao .h-elformWrap-2 {
  width: 25% !important;
  padding-right: 0.5rem;
}

.Yangbiao .h-elformWrap-5 {
  width: 74% !important;
  padding-right: 0.5rem;
}

.Yangbiao .h-elformWrap-3 {
  width: 85% !important;
  padding-right: 0.5rem;
}

.Yangbiao .h-elformWrap-3 .el-form-item__label {
  width: 12%;
  text-align: right;
}

.Yangbiao .h-elformWrap-35 {
  width: 77% !important;
  padding-right: 0.5rem;
}

.Yangbiao .h-elformWrap-35 .el-form-item__label {
  width: 20%;
  text-align: right;
}

.Yangbiao .h-elformWrap-4 {
  width: 100%;
  padding-right: 0.5rem;
}

.Yangbiao .h-elformWrap-4 .el-form-item__label {
  width: 10%;
}

.Yangbiao .h-elformWrap-4 .el-form-item__content {
  width: 89%;
}

.Yangbiao .w-elformWrap {
  width: 100% !important;
}

.w-elformWrap .el-form-item__label {
  width: 14% !important;
}

.w-elformWrap .el-form-item__content {
  width: 86% !important;
}

.Yangbiao .h-elformWrap-1 {
  width: 100%;
  padding-right: 0.5rem;
}

.Yangbiao .h-elformWrap-1 .el-form-item__label {
  width: 14%;
}

.Yangbiao .h-elformWrap-1 .el-form-item__content {
  width: 86%;
}

.Yangbiao.el-form-item__content .el-select {
  width: 100%;
}
</style>
